import { LoadingWaitIcon } from '@p2p/assets/svg';
import loadingWaitBgSrc from 'assets/img/loading-wait-bg.png';
import loadingWaitBgCoinsSrc from 'assets/img/loading-wait-bg-coins.png';

import styles from './Loading.module.scss';

export const Loading = () => {
  return (
    <div className={styles.container}>
      <img src={loadingWaitBgSrc} alt="Loading Wait Image" />
      <img
        className={styles.loadingBgCoins}
        src={loadingWaitBgCoinsSrc}
        alt="Loading Background Coins"
      />
      <div className={styles.loading}>
        <LoadingWaitIcon className={styles.loadingIcon} />
      </div>
    </div>
  );
};
